import { RouterProvider, createBrowserRouter } from "react-router-dom";
import RootLayout from "./components/RootLayout";
import HomePage from "./pages/Home";
import SignUp from "./pages/auth/Signup";
import Login from "./pages/auth/login";
import ProductsPage from "./pages/ProductsPage";
import DetailPage from "./pages/DetailPage";
import CartPage from "./pages/CartPage";
import CheckoutPage from "./pages/CheckoutPage";
import OrderHistory from "./pages/OrderHistory";
import Bill from "./components/orders/Bill";
import Promotion from "./pages/Promotion";
import AboutUs from "./pages/AboutUs";
import ForgotPassword from "./pages/auth/ForgotPassword";
import ChangePassword from "./pages/ChangePassword";
import ShopFinder from "./pages/shop/ShopFinder";
import News from "./pages/News/News";
import DetailNews from "./pages/News/DetailNews";
import LuckyGame from "./pages/LuckyWheel/LuckyGame";
import ServiceReg from "./pages/regulation/ServiceReg";
import SecurityReg from "./pages/regulation/SecurityReg";
import PaymentReg from "./pages/regulation/PaymentReg";

const router = createBrowserRouter([
  {
    path: "/",
    element: <RootLayout />,
    children: [
      { index: true, element: <HomePage /> },
      { path: "products", element: <ProductsPage /> },
      { path: "products/:productId", element: <DetailPage /> },
      { path: "cart", element: <CartPage /> },
      { path: "orders", element: <OrderHistory /> },
      { path: "orders/:id", element: <Bill /> },
      { path: "checkout", element: <CheckoutPage /> },
      { path: "login", element: <Login /> },
      { path: "register", element: <SignUp /> },
      { path: "forgot-password", element: <ForgotPassword /> },
      { path: "change-password", element: <ChangePassword /> },
      { path: "promotion", element: <Promotion /> },
      { path: "news", element: <News /> },
      { path: "news/:id", element: <DetailNews /> },
      { path: "about", element: <AboutUs /> },
      { path: "shop", element: <ShopFinder /> },
      { path: "lucky", element: <LuckyGame /> },
      { path: "service", element: <ServiceReg /> },
      { path: "security", element: <SecurityReg /> },
      { path: "payment", element: <PaymentReg /> },
    ],
  },
]);

function App() {
  return <RouterProvider router={router} />;
}

export default App;
